import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@mantine/core';
import { formatDateRange } from '../../utils/format';
import styles from './styles.scoped.css';

export default function ModalDeleteConfirm({ opened, onClose, onConfirm, isLoading, data }) {
  const getPeriodeString = () => {
    if (!data) return '-';
    const start = data.startDate || data.tanggalMulai;
    const end = data.endDate || data.tanggalBerakhir;
    return formatDateRange(start, end, 'D MMMM YYYY');
  };

  return (
    <Modal
      centered
      onClose={onClose}
      opened={opened}
      radius="lg"
      size="560px"
      styles={{
        header: {
          padding: '20px 24px 8px 24px',
          alignItems: 'flex-start',
        },
        title: {
          fontSize: '30px',
          fontWeight: 600,
          color: '#1e293b',
          lineHeight: '1.25',
        },
        body: {
          padding: '0 24px 24px 24px',
        },
      }}
      title="Hapus Informasi Besaran Subsidi"
      withCloseButton
    >
      <div style={{ textAlign: 'left' }}>
        <p className={styles.modalDeleteText}>
          Apakah Anda yakin untuk menghapus informasi besaran subsidi pada periode{' '}
          <strong style={{ color: '#1E293B', fontWeight: 700 }}>
            {getPeriodeString()}
          </strong>
          .
        </p>
        <div className={styles.modalFooter}>
          <button
            className={styles.btnOutlineGreen}
            onClick={onClose}
            style={{ flex: 1, borderRadius: '8px', padding: '10px 24px' }}
            type="button"
          >
            Batal
          </button>
          <button
            className={styles.btnDangerRed}
            disabled={isLoading}
            onClick={onConfirm}
            style={{ flex: 1, borderRadius: '8px', padding: '10px 24px' }}
            type="button"
          >
            {isLoading ? 'Menghapus...' : 'Hapus Informasi Besaran Subsidi'}
          </button>
        </div>
      </div>
    </Modal>
  );
}

ModalDeleteConfirm.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  opened: PropTypes.bool.isRequired,
};

